import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core';
import ArrowRight from '@material-ui/icons/ArrowForwardIos';
import { useLocation } from 'react-router-dom';

const useStyle = style =>
	makeStyles(theme => {
		const {
			breakpoints: { down },
			spacing,
		} = theme;
		return {
			root: {
				display: 'flex',
				fontFamily: 'Montserrat',
				textTransform: 'capitalize',
				padding: spacing(3),
				fontSize: '1.5rem',
				...style,
				[down('md')]: {
					paddingRight: spacing(1),
					paddingLeft: spacing(1),
					fontSize: '1.2rem',
				},
				[down('sm')]: {
					display: 'none',
				},
			},
			last: {
				color: theme.palette.action.main,
				fontWeight: 'bold',
			},
		};
	});

const pathNormalizer = (path, style) => {
	const parts = path.replaceAll('-', ' ').split('/').slice(1);
	let final = [];
	parts.forEach((part, i) =>
		final.push(
			<Fragment key={i}>
				{part}
				<ArrowRight style={{ margin: '0 6px' }} />
			</Fragment>
		)
	);
	final.pop();
	final.push(<span className={style.last}>{parts[parts.length - 1]}</span>);
	return final;
};

const CurRoute = props => {
	const style = useStyle(props)();
	const location = useLocation();
	return <div className={style.root}>{pathNormalizer(location.pathname, style)}</div>;
};

export default CurRoute;
